import styled from 'styled-components';
import { colors, typography, spacing } from '../../../styles/variables';

export const FooterContainer = styled.footer`
  padding: ${spacing.xl} 0 ${spacing.md};
  border-top: 1px solid rgba(229, 231, 235, 0.5);
`;

export const FooterContent = styled.div`
  max-width: ${spacing.maxContentWidth};
  margin: 0 auto;
  padding: 0 ${spacing.md};
`;

export const MainSection = styled.div`
  display: flex;
  justify-content: start;
  align-items: flex-start;
  margin-bottom: ${spacing.xl};
  gap: 10%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 0;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 400px;

  @media (max-width: 768px) {
    align-items: center;
    text-align: center;
    margin-bottom: ${spacing.lg};
  }
`;

export const Logo = styled.div`
  font-size: ${typography.sizes.h3};
  font-weight: ${typography.weights.semibold};
  color: ${colors.primary};
  margin-bottom: ${spacing.sm};

  img {
    height: auto;
  }
`;

export const Tagline = styled.p`
  color: ${colors.textSecondary};
  font-size: ${typography.fontSizeMd};
  margin-bottom: ${spacing.lg};
  text-align: left;
  line-height: 1.5;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: ${spacing.md};

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const SocialIcon = styled.a`
  color: ${colors.textSecondary};
  transition: color 0.2s ease;

  &:hover {
    color: ${colors.primary};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Navigation = styled.nav`
  display: flex;
  justify-content: center;
  gap: ${spacing.xl};
  margin-bottom: ${spacing.xl};
`;

export const NavigationSection = styled.div`
  display: flex;
  gap: ${spacing.xxxl};
  margin-top: 15px; /* Increased margin to lower the links further */

  @media (max-width: 768px) {
    display: none;
  }
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 200px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ContactTitle = styled.h4`
  color: ${colors.textPrimary};
  font-size: ${typography.fontSizeMd};
  font-weight: ${typography.weights.semibold};
  margin-bottom: ${spacing.md};
  font-family: ${typography.fontFamily};
`;

export const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.sm};
`;

export const ContactItem = styled.div`
  color: ${colors.textSecondary};
  font-size: ${typography.fontSizeMd};
  font-family: ${typography.fontFamily};
  
  a {
    color: ${colors.textSecondary};
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: ${colors.primary};
    }
  }
`;

export const NavigationColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.md};
`;

export const NavLink = styled.a`
  color: ${colors.textPrimary};
  text-decoration: none;
  transition: color 0.2s ease;
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSizeMd};

  &:hover {
    color: ${colors.primary};
  }
`;

export const BottomSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: ${spacing.md};
  border-top: 1px solid ${colors.borderLight};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: ${spacing.sm};
    text-align: center;
  }
`;

export const Copyright = styled.p`
  color: ${colors.textSecondary};
  font-size: ${typography.sizes.small};
`;

export const LegalLinks = styled.div`
  display: flex;
  gap: ${spacing.xl};

  @media (max-width: 768px) {
    gap: ${spacing.sm};
  }
`;

export const LegalLink = styled.a`
  color: ${colors.textSecondary};
  text-decoration: none;
  font-size: ${typography.sizes.small};
  transition: color 0.2s ease;

  &:hover {
    color: ${colors.primary};
  }
`;